export interface Locale {
  name: string;
  code: string;
}

export const supportedLocales: Locale[] = [
  {
    code: 'cs',
    name: 'Čeština',
  },
  {
    code: 'de',
    name: 'Deutsch',
  },
  {
    code: 'en-AU',
    name: 'English (AU)',
  },
  {
    code: 'en-GB',
    name: 'English (UK)',
  },
  {
    code: 'en-US',
    name: 'English (US)',
  },
  {
    code: 'es',
    name: 'Español',
  },
  {
    code: 'fi',
    name: 'Suomi',
  },
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'hu',
    name: 'Magyar',
  },
  {
    code: 'it',
    name: 'Italiano',
  },
  {
    code: 'ja',
    name: '日本語',
  },
  {
    code: 'nb',
    name: 'Norsk (bokmål)',
  },
  {
    code: 'nl',
    name: 'Nederlands',
  },
  {
    code: 'pl',
    name: 'Polski',
  },
  {
    code: 'pt-BR',
    name: 'Português (Brasil)',
  },
  {
    code: 'ru',
    name: 'Русский',
  },
  {
    code: 'sv',
    name: 'Svenska',
  },
  {
    code: 'th',
    name: 'ภาษาไทย',
  },
  {
    code: 'tr',
    name: 'Türkçe',
  },
  {
    code: 'uk',
    name: 'Українська',
  },
  {
    code: 'vi',
    name: 'Tiếng Việt',
  },
  {
    code: 'zh-Hans',
    name: '中文 (简体)',
  },
  {
    code: 'zh-Hant',
    name: '中文 (繁體)',
  },
];
